module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_grzanie_4.e04f4e3a.svg";